"use client";

import { IconWarning } from "@decibeltrade/react-icons";
import { css } from "styled-system/css";

import { Banner } from "@/components/banner";
import { Collapsible } from "@/components/collapsible";
import { useViewAs } from "@/contexts/view-as-context";
import { useIsTradingAllowed } from "@/hooks/use-require-trading-allowed";

/**
 * Global trading restriction banner shown on all pages
 * Handles geo restrictions
 * Page-specific banners handle technical warnings (network, latency, market status)
 */
export function GlobalRestrictionBanner() {
  const { isTradingAllowed, reason } = useIsTradingAllowed();
  const { isViewAsActive } = useViewAs();

  return (
    // No need to show the banner in view-as mode
    <Collapsible open={!isTradingAllowed && !isViewAsActive}>
      <Collapsible.Content>
        <Banner variant="critical" className={css({ width: "full" })}>
          <IconWarning className={css({ h: "16", w: "16", flexShrink: 0 })} />
          <span>{reason}</span>
        </Banner>
      </Collapsible.Content>
    </Collapsible>
  );
}
